/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Postal_CodeInputs */

const cs_form_postal_code = /** @type {(inputs: Form_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PSČ`)
};

const en_form_postal_code = /** @type {(inputs: Form_Postal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postal code`)
};

/**
* | output |
* | --- |
* | "Postal code" |
*
* @param {Form_Postal_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_postal_code = /** @type {((inputs?: Form_Postal_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Postal_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_postal_code(inputs)
	return cs_form_postal_code(inputs)
});